import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import AppLayout from '../../../layouts/AppLayout/AppLayout';
import { NioSection } from '../../../components';
import api from '../../../utils/api';
import { useTranslation } from '../../../i18n/I18nProvider';

function ConfirmEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage(t('confirmEmail.invalidLink'));
      return;
    }

    let cancelled = false;

    const confirm = async () => {
      try {
        const response = await api.confirmRequestEmail(token);
        if (cancelled) return;
        if (response?.success) {
          setStatus('success');
          setMessage(response.message || t('confirmEmail.defaultSuccess'));
        } else {
          setStatus('error');
          setMessage(response?.message || t('confirmEmail.defaultError'));
        }
      } catch (error) {
        if (cancelled) return;
        setStatus('error');
        setMessage(error.message || t('confirmEmail.defaultError'));
      }
    };

    confirm();
    return () => {
      cancelled = true;
    };
  }, [token, t]);

  return (
    <AppLayout title={t('confirmEmail.pageTitle')} rootClass="layout-1">
      <NioSection className="pt-120 pt-lg-160 pb-5">
        <NioSection.Content>
          <div className="mx-auto text-center" style={{ maxWidth: 560 }}>
            {status === 'loading' ? (
              <>
                <h2 className="mb-3">{t('confirmEmail.loadingTitle')}</h2>
                <p className="text-muted mb-0">{t('confirmEmail.loadingBody')}</p>
              </>
            ) : null}

            {status === 'success' ? (
              <>
                <h2 className="mb-3 text-success">{t('confirmEmail.successTitle')}</h2>
                <p className="mb-4">{message}</p>
                <Link to="/index-bs-management" className="btn btn-primary">
                  {t('common.backToHome')}
                </Link>
              </>
            ) : null}

            {status === 'error' ? (
              <>
                <h2 className="mb-3 text-danger">{t('confirmEmail.errorTitle')}</h2>
                <p className="mb-4">{message}</p>
                <Link to="/index-bs-management" className="btn btn-primary">
                  {t('common.backToHome')}
                </Link>
              </>
            ) : null}
          </div>
        </NioSection.Content>
      </NioSection>
    </AppLayout>
  );
}

export default ConfirmEmail;
